var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"pagination":false,"editable":false},scopedSlots:_vm._u([{key:"item.venues",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm._f("prettyArray")(_vm.getVenueNames(value)))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }